<script setup lang="ts">
import { computed } from 'vue'
import { useUserStore } from '@/stores/user'
import { formatDateTime } from '@/utils/format'

const user = useUserStore()

const expiresLabel = computed(() => formatDateTime(user.profile?.subscription_expires_at ?? null))

// Подписка существует, если она активна или задана дата окончания.
const hasSubscription = computed(
  () => user.subscriptionActive || !!user.profile?.subscription_expires_at,
)
</script>

<template>
  <template v-if="user.profile">
    <!-- Есть подписка -->
    <div
      v-if="hasSubscription"
      class="panel flex items-center justify-between gap-3 !py-3 !px-4"
    >
      <div class="flex items-center gap-2">
        <span class="badge badge-success">Подписка</span>
        <span class="text-sm font-bold">Активна</span>
      </div>
      <div v-if="expiresLabel !== '—'" class="text-sm text-muted">
        до {{ expiresLabel }}
      </div>
    </div>

    <!-- Нет активных подписок -->
    <div v-else class="panel flex items-center gap-2 !py-3 !px-4">
      <span class="badge badge-warning">Подписка</span>
      <span class="text-sm font-bold text-muted">Нет активных подписок</span>
    </div>
  </template>
</template>
